import updateReduxAction from '../../../../redux/actions/update'
import getReduxSelector from '../../../../redux/selectors/get'
import { getIdReduxUtil } from '../../../../redux/utils/get-id'
import getInstanceReduxUtil from '../../../../redux/utils/get-instance'
import { getPathReduxUtil } from '../../../../redux/utils/get-path'
import isNewReduxUtil from '../../../../redux/utils/is-new'
import getCurrentWorkoutExerciseStartWorkoutSelect
  from '../../../../start-workout/selectors/get-current-workout-exercise'
import hasStartedStartWorkoutSelect from '../../../../start-workout/selectors/has-started'
import { saveWorkoutExerciseAction } from '../save'
import getCurrentWorkoutExerciseSelect from '../../selectors/get-current'
import updateDataWorkoutAction from '../../../../workout/redux/actions/update-data'
import updateLocalHasAssociationChangeWorkoutAction
  from '../../../../workout/redux/actions/update-local-has-association-change'
import { logUtil } from 'packages/src'

function updateWorkoutExerciseAction (action) {
  return async (dispatch, getState) => {
    const {
      key,
      value,
      keys,
      values,
      workoutExercise,
      shouldKeepWorkoutRecommended,
      omitWorkoutUpdate,
      shouldNotSave,
      path
    } = action.payload
    const updatesParam = action.payload.updates
    // Update the workout exercise
    let newWorkoutExercise = path
      ? getReduxSelector(path)(getState())
      : getInstanceReduxUtil(getState(), workoutExercise)
    if (!newWorkoutExercise && hasStartedStartWorkoutSelect(getState())) {
      newWorkoutExercise = getCurrentWorkoutExerciseStartWorkoutSelect(getState())
    } else if (!newWorkoutExercise) {
      newWorkoutExercise = getCurrentWorkoutExerciseSelect(getState())
    }

    if (!newWorkoutExercise) {
      logUtil('').warn(`workout exercise not found for key ${key}`)
      return
    }

    const updates = updatesParam || {}
    if (keys && !updatesParam) {
      keys.forEach((key, index) => {
        updates[key] = values[index]
      })
    } else if (!updatesParam) {
      updates[key] = value
    }
    dispatch(updateReduxAction({
      type: action.type,
      payload: {
        path: getPathReduxUtil(newWorkoutExercise),
        updates
      }
    }))

    if (omitWorkoutUpdate) {
      return
    }

    // Update the workout data
    await dispatch(updateDataWorkoutAction())

    if (isNewReduxUtil(newWorkoutExercise)) {
      dispatch(updateLocalHasAssociationChangeWorkoutAction({
        shouldKeepWorkoutRecommended
      }))
    }

    if (shouldNotSave) {
      return
    }
    dispatch(saveWorkoutExerciseAction(getIdReduxUtil(workoutExercise)))
  }
}

export default updateWorkoutExerciseAction
